import { ImgStatusEnum } from 'enum/uploadImg-status.enum'
import I18n from 'i18n'

const fieldsPrefix = 'administration.courses.new.form.courseFields'

const getPlainTextFromHtml = (html: string): string => {
  if (!html) return ''
  const doc = new DOMParser().parseFromString(html, 'text/html')
  return (doc.body.textContent || '').replace(/\u00a0/g, ' ').trim()
}

const isValidCourseName = (name: string): boolean =>
  /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑüÜ\s]+$/.test(name)

interface ValidateParams {
  name: string
  description: string
  hours?: number | string
  normative?: boolean
  attestationsEnabled?: boolean
}

export const validate = ({
  name,
  description,
  hours,
  normative = false,
  attestationsEnabled = false,
}: ValidateParams) => {
  const errors = {
    name: '',
    description: '',
    hours: '',
    banner: '',
    thumbnail: '',
    courseType: '',
    startDate: '',
    untilDate: '',
    optionalProfiles: '',
    requiredProfiles: '',
    state: '',
    sendEmail: '',
    invitationNotification: '',
    lessons: '',
    hasStarted: '',
  }

  const trimmedName = name?.trim() || ''
  const isNormativeContext = attestationsEnabled && normative

  if (!trimmedName) {
    errors.name = I18n.t(`${fieldsPrefix}.name.required`)
  } else if (isNormativeContext && !isValidCourseName(trimmedName)) {
    errors.name = I18n.t(`${fieldsPrefix}.name.invalidFormat`)
  }

  if (!getPlainTextFromHtml(description)) {
    errors.description = I18n.t(`${fieldsPrefix}.description.required`)
  }

  if (isNormativeContext) {
    const hoursValue = hours === '' || hours === undefined ? NaN : Number(hours)
    if (Number.isNaN(hoursValue) || hoursValue <= 0) {
      errors.hours = I18n.t(`${fieldsPrefix}.duration.required`)
    }
  }

  return errors
}

export const imgFileValidate = (file: any) => {
  console.log('validating image')
  let img: any = undefined
  img = new Image()
  return new Promise((resolve: any) => {
    if (file.type === 'image/jpeg' || file.type === 'image/png') {
      img.src = URL.createObjectURL(file)
      img.onload = function () {
        if (file.size > 10000000) {
          resolve(ImgStatusEnum.maxSizeExceeded)
        } else {
          resolve(ImgStatusEnum.success)
        }
      }
    } else {
      resolve(ImgStatusEnum.wrongFileType)
    }
  })
}
